// extracted by mini-css-extract-plugin
export var section = "_2g-1";
export var topNav = "_2g-0";